/**
 * Объект частично совместим с объектом конфига роутера, но в данный момент **не поддерживаются вложенные пути**
 */
export const smeRoutes = [
    {
        name: 'smemainpage',
        path: '/sme',
        component: () => import(/* webpackChunkName: "smeMain" */ '/local/templates/redesign/src/pages/sme/smeMain.vue'),
    },
    {
        name: 'sme-promo-mortgage',
        path: '/sme/promo/mortgage',
        component: () => import(/* webpackChunkName: "smePromoMortgage" */ '/local/templates/redesign/src/pages/sme/smePromoMortgage.vue'),
    },
    {
        name: 'sme-mortgage',
        path: '/sme/mortgage/(.*)',
        component: () => import(/* webpackChunkName: "smeMortgage" */ '/local/templates/redesign/src/pages/sme/smeMortgage.vue'),
    },
    {
        name: 'sme-registration',
        path: '/sme/registration',
        component: () => import(/* webpackChunkName: "smeRegistrationPage" */ '/local/templates/redesign/src/pages/sme/smeRegistrationPage.vue'),
    },
    {
        name: 'sme-agents-form',
        path: '/sme/agents/form',
        component: () => import(/* webpackChunkName: "smeAgentsFormPage" */ '/local/templates/redesign/src/pages/sme/smeAgentsFormPage.vue'),
    },
    {
        name: 'sme-credits',
        path: '/sme/credits/(.*)',
        component: () => import(/* webpackChunkName: "smeCredits" */ '/local/templates/redesign/src/pages/sme/smeCredits.vue'),
    },
    {
        name: 'sme-cards',
        path: '/sme/cards',
        component: () => import(/* webpackChunkName: "smeCards" */ '/local/templates/redesign/src/pages/sme/smeCards.vue'),
    },
    {
        name: 'sme-izs',
        path: '/sme/izs',
        component: () => import(/* webpackChunkName: "smeIzs" */ '/local/templates/redesign/src/pages/sme/smeIzs.vue'),
    },
    {
        name: 'sme-contractors',
        path: '/sme/contractors',
        component: () => import(/* webpackChunkName: "smeContractors" */ '/local/templates/redesign/src/pages/sme/smeContractors.vue'),
    },
    {
        name: 'sme-zp',
        path: '/sme/zp',
        component: () => import(/* webpackChunkName: "smeZp" */ '/local/templates/redesign/src/pages/sme/smeZp.vue'),
    },
    {
        name: 'sme-deposits',
        path: '/sme/deposits',
        component: () => import(/* webpackChunkName: "smeDeposits" */ '/local/templates/redesign/src/pages/sme/smeDeposits.vue'),
    },
    {
        name: 'sme-online-bank',
        path: '/sme/online/bank/:slug?',
        component: () => import(/* webpackChunkName: "smeOnlineBank" */ '/local/templates/redesign/src/pages/sme/smeOnlineBank.vue'),
    },
    {
        name: 'sme-online-detail',
        path: '/sme/online/:detail?',
        component: () => import(/* webpackChunkName: "smeOnlineDetail" */ '/local/templates/redesign/src/pages/sme/smeOnlineDetail.vue'),
    },
    {
        name: 'sme-rko-acquiring',
        path: '/sme/rko/acquiring',
        component: () => import(/* webpackChunkName: "smeRkoAcquiring" */ '/local/templates/redesign/src/pages/sme/smeRkoAcquiring.vue'),
    },
    {
        name: 'sme-rko-internet-acquiring',
        path: '/sme/rko/internet-acquiring',
        component: () => import(/* webpackChunkName: "smeRkoInternetAcquiring" */ '/local/templates/redesign/src/pages/sme/smeRkoInternetAcquiring.vue'),
    },
    {
        name: 'sme-rko-rates',
        path: '/sme/rko/rates',
        component: () => import(/* webpackChunkName: "smeRkoRates" */ '/local/templates/redesign/src/pages/sme/smeRkoRates.vue'),
    },
    {
        name: 'sme-ved',
        path: '/sme/ved',
        component: () => import(/* webpackChunkName: "smeVed" */ '/local/templates/redesign/src/pages/sme/smeVed.vue'),
    },
    {
        name: 'sme-okn',
        path: '/sme/okn',
        component: () => import(/* webpackChunkName: "smeOkn" */ '/local/templates/redesign/src/pages/sme/smeOkn.vue'),
    },
    {
        name: 'sme-webinar',
        path: '/sme/webinar',
        component: () => import(/* webpackChunkName: "smeWebinar" */ '/local/templates/redesign/src/pages/sme/smeWebinar.vue'),
    },
    {
        name: 'sme-special',
        path: '/sme/special',
        component: () => import(/* webpackChunkName: "smeSpecial" */ '/local/templates/redesign/src/pages/sme/smeSpecial.vue'),
    },
    {
        name: 'sme-sbp',
        path: '/sme/sbp',
        component: () => import(/* webpackChunkName: "smeSbp" */ '/local/templates/redesign/src/pages/sme/smeSbp.vue'),
    },
    {
        name: 'sme-working-capital',
        path: '/sme/working-capital',
        component: () => import(/* webpackChunkName: "smeWorkingCapital" */ '/local/templates/redesign/src/pages/sme/smeWorkingCapital.vue'),
    },
    {
        name: 'sme-developers-form',
        path: '/sme/developers/form',
        component: () => import(/* webpackChunkName: "smeDevelopersFormPage" */ '/local/templates/redesign/src/pages/sme/smeDevelopersFormPage.vue'),
    },
    {
        name: 'sme-acceleration',
        path: '/sme/acceleration/',
        component: () => import(/* webpackChunkName: "smeAcceleration" */ '/local/templates/redesign/src/pages/sme/smeAcceleration.vue'),
    },
    {
        name: 'sme-partners',
        path: '/sme/partners/',
        component: () => import(/* webpackChunkName: "smePartners" */ '/local/templates/redesign/src/pages/sme/smePartners.vue'),
    },
    {
        name: 'sme-detail',
        path: '/sme/(.*)',
        component: () => import(/* webpackChunkName: "smeDetail" */ '/local/templates/redesign/src/pages/sme/smeDetail.vue'),
    },
    {
        name: 'sme-contruction',
        path: '/sme/construction/',
        component: () => import(/* webpackChunkName: "smeConstruction" */ '/local/templates/redesign/src/pages/sme/smeConstruction.vue'),
    },
    {
        name: 'sme-leads',
        path: '/sme-leads/',
        component: () => import(/* webpackChunkName: "smeLeads" */ '/local/templates/redesign/src/pages/sme/smeLeads.vue'),
    },

];
